import { FranklinHelpCenter as FranklinHelpCenterComponent } from "./components/franklin-help-center";
import {
  FranklinProvider as FranklinProviderComponent,
  useFranklinContext as useFranklinContextHook,
} from "./context/franklin-context";
import { useFranklin as useFranklinHook } from "./hooks/use-franklin";
import { cn as cnUtility, formatDate as formatDateUtility } from "./lib/utils";
import type {
  Article as ArticleType,
  Case as CaseType,
  Category as CategoryType,
  FranklinContextPayload as FranklinContextPayloadType,
  FranklinHelpCenterHandle as FranklinHelpCenterHandleType,
  FranklinHelpCenterProps as FranklinHelpCenterPropsType,
  FranklinTab as FranklinTabType,
  FranklinThemeConfig as FranklinThemeConfigType,
  Message as MessageType,
} from "./types";

const FranklinHelpCenter = FranklinHelpCenterComponent;
const FranklinProvider = FranklinProviderComponent;
const useFranklinContext = useFranklinContextHook;
const useFranklin = useFranklinHook;

const cn = cnUtility;
const formatDate = formatDateUtility;

type Article = ArticleType;
type Case = CaseType;
type Category = CategoryType;
type FranklinContextPayload = FranklinContextPayloadType;
type FranklinHelpCenterHandle = FranklinHelpCenterHandleType;
type FranklinHelpCenterProps = FranklinHelpCenterPropsType;
type FranklinTab = FranklinTabType;
type FranklinThemeConfig = FranklinThemeConfigType;
type Message = MessageType;

export {
  FranklinHelpCenter,
  FranklinProvider,
  cn,
  formatDate,
  useFranklin,
  useFranklinContext,
};

export type {
  Article,
  Case,
  Category,
  FranklinContextPayload,
  FranklinHelpCenterHandle,
  FranklinHelpCenterProps,
  FranklinTab,
  FranklinThemeConfig,
  Message,
};

export const FRANKLIN_SDK_REACT_ENTRY = true;
